import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { InspectionEmailComponent }        from './inspection.email.component';
import { InspectionTemplateComponent }     from './inspection.template.component';
import { InspectionTemplateItemComponent } from './inspection.template.item.component';
import { SharedModule }                    from '../shared/shared.module';
import { TableModule }                     from '../table/table.module';

@NgModule({
  declarations: [
    InspectionEmailComponent,
    InspectionTemplateComponent,
    InspectionTemplateItemComponent
  ],
  entryComponents: [
    InspectionEmailComponent,
    InspectionTemplateComponent,
    InspectionTemplateItemComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class InspectionsModule {}
